import axios, { AxiosRequestConfig } from "axios";
import { MarketApiResponse } from "src/model/shop.model";
import { setResellOShiftHost } from "src/utils/BasePathTools";
import { MultimarketParams } from "../api.models";

export async function getMultimarket( {iso, lang, role="", purifiedUrl=false,}: MultimarketParams ): Promise<MarketApiResponse> {
  const options: AxiosRequestConfig = {
    method: "GET",
  };

  let url = setResellOShiftHost(`/itxrest/2/resell-store/store/multimarket/${iso}?language=${lang}${role?`&role=${role}`:""}`,);

  if (purifiedUrl) url = url.replace(/language=undefined/g, "");

  try {
    const response = await axios(url, options);
    return await response.data;
  } catch (error) {
    return Promise.reject(new Error("Failed to fetch multimarket data"));
  }
}
